import { wordpressClient } from '../config/axiosConfig'
import { create } from 'zustand'

interface NextEventState {
  nextEventData: NextEventData[]
  getEventData: (slug: string) => NextEventData | undefined
  loaded: boolean
}

export interface NextEventData {
  eventId: number
  slug: string
  isOpenSunday: boolean
  eventLogo: string
  eventHintergrund: string
  eventTickets: string
  eventDatum: string
  eventHalle: string
  eventEinlass: string
  eventBeginn: string
  eventName: string
}

interface NextEventResponse {
  id: number
  slug: string
  acf: {
    showart: string
    event_logo: string
    event_hintergrund: string
    event_tickets: string
    event_datum: string
    event_halle: string
    event_einlass: string
    event_beginn: string
    event_name: string
  }
}

const compareEventByDate = (eventA: NextEventData, eventB: NextEventData): number => {
  const [dayA, monthA, yearA] = eventA.eventDatum.split('.').map(Number)
  const [hoursA, minutesA] = eventA.eventBeginn.split(':').map(Number)
  const [dayB, monthB, yearB] = eventB.eventDatum.split('.').map(Number)
  const [hoursB, minutesB] = eventB.eventBeginn.split(':').map(Number)
  const dateA = new Date(yearA, monthA - 1, dayA, hoursA, minutesA)
  const dateB = new Date(yearB, monthB - 1, dayB, hoursB, minutesB)
  return dateA > dateB ? 1 : dateA < dateB ? -1 : 0
}

export const useNextEventStore = create<NextEventState>()(() => ({
  nextEventData: [],
  getEventData: (slug: string): NextEventData | undefined => {
    return useNextEventStore.getState().nextEventData.find((eventData) => eventData.slug === slug)
  },
  loaded: false,
}))

wordpressClient
  .get<NextEventResponse[]>('posts', {
    params: {
      // prettier-ignore
      'per_page': 100,
    },
  })
  .then((response) => {
    if (response.status === 200) {
      const currentDate = new Date()

      const nextEventData: NextEventData[] = response.data
        .filter(({ acf }) => {
          const [day, month, year] = acf.event_datum.split('.').map(Number)
          const [hours, minutes] = acf.event_beginn.split(':').map(Number)

          const eventDate = new Date(year, month - 1, day, hours, minutes)
          return eventDate > currentDate
        })
        .map((show) => {
          const acf = show.acf
          return {
            eventId: show.id,
            slug: show.slug,
            isOpenSunday: acf.showart === 'Open Sunday',
            eventLogo: acf.event_logo,
            eventHintergrund: acf.event_hintergrund,
            eventTickets: acf.event_tickets,
            eventDatum:
              acf.event_datum && acf.event_datum.trim() !== '' ? acf.event_datum : 'Datum: TBA',
            eventHalle:
              acf.event_halle && acf.event_halle.trim() !== '' ? acf.event_halle : 'Location: TBA',
            eventEinlass:
              acf.event_einlass && acf.event_einlass.trim() !== '' ? acf.event_einlass : 'TBA',
            eventBeginn:
              acf.event_beginn && acf.event_beginn.trim() !== '' ? acf.event_beginn : 'TBA',
            eventName:
              acf.event_name && acf.event_name.trim() !== '' ? acf.event_name : 'Eventname: TBA',
          }
        })
        .sort(compareEventByDate)

      useNextEventStore.setState({ nextEventData: nextEventData, loaded: true })
    } else {
      console.error('Error fetching data')
    }
  })
  .catch((error) => {
    console.error('Error:', error)
  })
